<template>
	<div>
		<div class="modal fade" id="addQuoteRequestModal" ref="modalEle" tabindex="-1" role="dialog"
			aria-labelledby="modelTitleId" aria-hidden="true">
			<div class="modal-dialog modal-full-width" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Dyspozycja magazynowa</h5>
						<button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>

					<div class="modal-body pt-3">

						<div class="table-responsive" style="border-bottom:1px solid #ddd; padding-bottom:20px">
							<div class="mb-3">

								<div class="d-flex gap-3 align-items-end flex-wrap">

									<div>
										<label class="form-label fw-semibold mb-1">Typ dokumentu</label>
										<select v-model="documentType" class="form-select form-select-sm w-auto"
											style="min-width: 160px">
											<option :value="null" disabled>— wybierz dokument —</option>
											<option v-for="opt in documentTypeOptions" :key="opt" :value="opt">
												{{ opt.toUpperCase() }}
											</option>
										</select>
									</div>

									<div v-if="documentType && documentType !== null">
										<label class="form-label fw-semibold mb-1">Magazyn źródłowy</label>
										<select class="form-select form-select-sm w-auto"
											v-model.number="sourceWarehouseId" @change="reloadArticles">
											<option :value="null" disabled>— wybierz magazyn —</option>
											<option v-for="w in sourceWarehouses" :key="w.id" :value="w.id">
												{{ w.short_name || w.name }}
											</option>

										</select>
									</div>

									<div v-if="sourceWarehouseId && sourceWarehouseId !== null && documentType == 'mm'">
										<label class="form-label fw-semibold mb-1">Magazyn docelowy</label>

										<select class="form-select form-select-sm w-auto"
											v-model.number="globalWarehouseId" @change="applyGlobalWarehouse">

											<option :value="null" disabled>— wybierz magazyn —</option>

											<option v-for="w in targetWarehouses" :key="w.id" :value="w.id">
												{{ w.short_name || w.name }}
											</option>

										</select>
									</div>

									<div class="d-flex flex-column justify-content-end">
										<label class="form-label fw-semibold mb-1">&nbsp;</label>
										<button type="button" class="btn btn-outline-secondary btn-sm"
											@click="refreshDocNumber" :disabled="isGeneratingNumber">
											Odśwież numer
										</button>
									</div>

								</div>

								<div v-if="sourceWarehouseId && sourceWarehouseId !== null && documentType == 'wz'"
									class="mt-3 p-3 border rounded bg-light position-relative">

									<label class="form-label fw-semibold">Wybierz klienta</label>

									<input id="customer_search" type="text" class="form-control form-control-sm"
										v-model="customerSearch" placeholder="Wpisz nazwę klienta..."
										@focus="showDropdown = true" @blur="hideDropdown" />

									<div v-if="showDropdown && filteredCustomers.length"
										class="border rounded bg-white position-absolute w-100 z-3"
										style="max-height: 200px; overflow-y: auto;">
										<div v-for="customer in filteredCustomers" :key="customer.id"
											class="px-2 py-1 hover-bg" style="cursor: pointer;"
											@mousedown.prevent="selectCustomer(customer)">
											{{ customer.name }}
										</div>
									</div>

									<label class="form-label fw-semibold mt-3">Dane odbiorcy</label>

									<textarea v-model="who_buying" class="form-control form-control-sm" rows="4">
    </textarea>

								</div>

							</div>
							<div
								v-if="sourceWarehouseId && sourceWarehouseId !== null && documentType && documentType !== null">
								<h6 class="mt-1 mb-4">
									Wybrane pozycje będą przypisane do dokumentu:
									<b>{{ documentNumber ?? 'generowanie numeru...' }}</b>
								</h6>
							</div>
							<div v-else>
								<h6 class="mt-1 mb-4">Wybierz rodzaj dyspozycji magazynowej (dokument)</h6>
							</div>
							<div v-if="selectedArticles.length">
								<div class="card mb-3">
									<div class="card-body">

										<h6 class="mb-3">
											Dane wspólne dla dokumentu
										</h6>

										<div class="row g-2">

											<div class="col-md-3">
												<label class="form-label">
													Komentarz
												</label>
												<input type="text" class="form-control form-control-sm"
													v-model="globalComment">
											</div>

											<div class="col-md-3">
												<label class="form-label">
													Komentarz na wydruku
												</label>
												<input type="text" class="form-control form-control-sm"
													v-model="globalAdditionalComment">
											</div>

											<div class="col-md-3">
												<label class="form-label">
													Osoba otrzymująca
												</label>

												<input type="text" class="form-control form-control-sm"
													v-model="who_receiving">
											</div>

											<div class="col-md-3">
												<label class="form-label">
													Cel
												</label>

												<input type="text" class="form-control form-control-sm"
													v-model="globalPurpose">
											</div>

										</div>
									</div>
								</div>
								<h5 class="mb-3">Lista wybranych artykułów</h5>

								<table class="table table-striped">
									<thead>
										<tr>
											<th></th>
											<th>#</th>
											<th>Nr Katalogowy</th>
											<th>Model</th>
											<th>J.m.</th>
											<th>Nazwa/Opis</th>
											<th style="min-width:200px">Z magazynu</th>
											<th style="min-width:180px">Do magazynu</th>
											<th>Ilość</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="article in selectedArticles" :key="article.id">
											<td>
												<button @click="removeFromSelectedArticles(article.id)"
													class="btn btn-outline-danger btn-xs">Usuń
												</button>
											</td>

											<td>{{ article.id }}</td>
											<td>{{ article.catalog_number }}</td>
											<td>{{ article.model }}</td>
											<td>{{ article.article_unit?.name }}</td>
											<td>{{ article.description }}</td>

											<td>
												<span class="fw-semibold">
													{{ getSourceWarehouseName(article.previous_warehouse_id) }}
												</span>
												<div class="text-muted small">
													(ilość: {{ getSourceQuantity(article) }})
												</div>
											</td>


											<td>
												<span class="fw-semibold">
													{{ getWarehouseName(article.warehouse_id) }}
												</span>
											</td>

											<!-- ILOŚĆ + POLA OPISOWE -->
											<td>
												<input style="min-width:80px; max-width:150px" type="number"
													:step="isIntegerUnit(article.article_unit?.name) ? 1 : 0.01"
													:min="isIntegerUnit(article.article_unit?.name) ? 1 : 0.01"
													:max="documentType !== 'pw' ? getAvailableQuantity(article) : null"
													v-model.number="article.quantity" @input="onQuantityInput(article)"
													@keydown="blockNonNumeric($event, article.article_unit?.name)"
													class="form-control form-control-sm" />
												<input type="hidden" v-model="article.comment">
												<input type="hidden" v-model="article.purpose">
											</td>


										</tr>
									</tbody>
								</table>

								<div class="mt-3 d-flex align-items-center gap-3">

									<button type="button" class="btn btn-primary" @click="submit"
										:disabled="!canSubmit || isSubmitting"
										v-if="canSubmit && (documentType !== 'mm' || globalWarehouseId)">
										Dodaj wybrane pozycje
									</button>

									<div class="form-check mb-0">
										<input id="closeDocument" type="checkbox" class="form-check-input"
											v-model="closeDocument" />
										<label for="closeDocument" class="form-check-label">
											Zamknij dokument
										</label>
									</div>

									<div class="form-check mb-0">
										<input id="printPdf" type="checkbox" class="form-check-input"
											v-model="printPdf" />
										<label for="printPdf" class="form-check-label">
											Drukuj PDF
										</label>
									</div>

								</div>
							</div>
						</div>

						<div v-if="documentType === 'mm' && sourceWarehouseId && !globalWarehouseId"
							class="alert alert-info mt-3">
							Wybierz magazyn docelowy dla dokumentu MM!
						</div>

						<!-- LISTA ARTYKUŁÓW -->
						<div v-if="sourceWarehouseId && documentType && (documentType !== 'mm' || globalWarehouseId)">
							<h5 class="pt-4 pb-2">Lista dostępnych artykułów</h5>

							<ejs-grid ref="addItemMovementGridRef" id="addItemMovementGrid" height="500px"
								:dataSource="articlesDataManager" :allowPaging="true" :allowSorting="true"
								:allowFiltering="true" :pageSettings="pageSettings" :editSettings="editSettings"
								:filterSettings="filterOptions" :toolbar="toolbar" :toolbarClick="onToolbarClick"
								:actionBegin="actionBegin" :actionComplete="actionComplete" :showColumnChooser='true'
								:allowResizing='true' :enablePersistence='true'>
								<e-columns>
									<e-column headerText="Dodaj" width="80" :template="'addTemplate'" textAlign="Center"
										:allowEditing="false" />
									<e-column field="id" headerText="ID" width="100" :isPrimaryKey="true"
										:visible="false" :allowEditing="false" />
									<e-column field="photos" headerText="Zdjęcia" width="150"
										:template="'imageTemplate'" :allowFiltering="false" :allowSorting="false"
										type="string" :allowEditing="false" :visible="false" />
									<e-column field="catalog_number" headerText="Nr katalogowy" type="string"
										:allowEditing="false" />
									<e-column field="model" headerText="Model" type="string" :allowEditing="false" />
									<e-column field="description" headerText="Nazwa/Opis" type="string"
										:allowEditing="false" />
									<e-column field="article_unit.name" headerText="J.m." :visible="true"
										:allowEditing="false" />
									<e-column field="available_items.quantity" headerText="Stany magazynowe" width="150"
										format="N2" :filter="filterNumeric" type="string" :allowEditing="false" />
									<e-column field="price_netto_zl" headerText="Cena Netto zł" width="150" format="N2"
										:filter="filterNumeric" type="string" :allowEditing="false" />
									<e-column field="location" headerText="Lokalizacja" :defaultValue="null" width="200"
										:filter="filterDefault" :allowEditing="false" />
									<e-column field="producer_name" headerText="Producent" width="150" type="string"
										:allowSorting="false" :allowFiltering="false"></e-column>

									<e-column field="link" headerText="Link" :defaultValue="null" type="string"
										:filter="filterDefault" :template="'linkTemplate'" :allowEditing="false" />
								</e-columns>

								<template v-slot:addTemplate="{ data }">
									<button @click="addToSelected(data)" class="btn btn-xs btn-outline-primary"
										:disabled="documentType !== 'pw' && (!data.available_items?.quantity || data.available_items.quantity < 1)"
										:title="documentType !== 'pw' && (!data.available_items?.quantity || data.available_items.quantity < 1)
											? 'Brak dostępnych sztuk dla tego artykułu'
											: ''">
										<template v-if="!isArticleSelected(data.id)">
											Dodaj
										</template>
										<template v-else>
											Wybrano
										</template>
									</button>
								</template>


								<template v-slot:linkTemplate="{ data }">
									<a class="link link-primary" target="_blank" rel="noopener noreferrer"
										:href="data.link">{{
											data.link
										}}</a>
								</template>

								<template v-slot:imageTemplate="{ data }">
									<div v-if="data.photos && data.photos.length">
										<img :src="`/${data.photos[0].photo_path}`" alt="Zdjęcie"
											style="max-height: 100px; max-width: 150px" />
									</div>
								</template>
							</ejs-grid>
						</div>

					</div>
				</div>
			</div>
		</div>

		<div class="modal fade" id="articleDetailsModal" ref="articleDetailsModalRef" tabindex="-1">

			<div class="modal-dialog">
				<div class="modal-content">

					<div class="modal-header">
						<h5 class="modal-title">
							Dodaj artykuł
						</h5>

						<button type="button" class="btn-close" data-bs-dismiss="modal">
						</button>
					</div>

					<div class="modal-body" v-if="editingArticle">
						<div class="mb-3">
							<div>
								<label class="form-label">Ilość</label>
								<div class="input-group">
									<input type="number" class="form-control"
										:min="isIntegerUnit(editingArticle.article_unit?.name) ? 1 : 0.01"
										:step="isIntegerUnit(editingArticle.article_unit?.name) ? 1 : 0.01"
										:max="documentType !== 'pw' ? getAvailableQuantity(editingArticle) : null"
										v-model.number="editingArticle.quantity"
										@input="onQuantityInput(editingArticle)"
										@keydown="blockNonNumeric($event, editingArticle.article_unit?.name)" />
									<span class="input-group-text">
										{{ editingArticle.article_unit?.name || '-' }}
									</span>
								</div>
							</div>
						</div>
					</div>

					<div class="modal-footer">
						<button class="btn btn-secondary" data-bs-dismiss="modal">
							Anuluj
						</button>

						<button class="btn btn-primary" @click="saveArticleFromModal">
							Dodaj artykuł
						</button>
					</div>

				</div>
			</div>
		</div>

	</div>
</template>

<script>
import axios from 'axios'
import { ref, nextTick } from 'vue'
import { Modal } from 'bootstrap'
import { useForm, usePage } from '@inertiajs/vue3'
import { DatePickerComponent } from '@syncfusion/ej2-vue-calendars'
import { GridComponent, ColumnsDirective, ColumnDirective, ColumnChooser, Toolbar, Page, Sort, Filter, Reorder, Resize } from '@syncfusion/ej2-vue-grids'
import { DataManager, Predicate, Query, WebMethodAdaptor } from '@syncfusion/ej2-data'

export default {
	components: {
		'ejs-grid': GridComponent,
		'e-columns': ColumnsDirective,
		'e-column': ColumnDirective,
		'ejs-datepicker': DatePickerComponent,
	},
	provide: {
		grid: [ColumnChooser, Toolbar, Page, Sort, Filter, Reorder, Resize]
	},
	props: {
		customers: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			warehousesLocal: [],
			closeDocument: false,
			printPdf: false,
			globalComment: '',
			globalAdditionalComment: '',
			customer_id: '',
			customerSearch: '',
			showDropdown: false,
			globalPurpose: '',
			sourceWarehouseId: null,
			articlesDataManager: [],
			articleDetailsModal: null,
			editingArticle: null,
			globalWarehouseId: null,
			_lastGlobalWarehouseId: null,
			pageSettings: { pageSize: 50, pageCount: 5, pageSizes: [10, 20, 50, 100, 200, 500, 1000] },
			filterOptions: { type: 'Menu', operator: 'contains' },
			filterDefault: { operator: 'contains', params: { minLength: 2 } },
			filterNumeric: { operator: 'equal' },
			editSettings: { allowEditing: true, mode: 'Batch' },
			toolbar: [
				{ text: 'Resetuj filtry', prefixIcon: 'e-reset', id: 'reset_filters' },
				{ text: 'Lista artykułów', prefixIcon: 'e-table-of-content', id: 'articles_list' },
				{ text: 'Search', prefixIcon: 'e-search', id: 'search', align: 'center' },
				{ text: "Przywróć domyślny", prefixIcon: 'e-undo', id: "restore", align: 'right' },
				{ text: 'Odśwież', prefixIcon: 'e-refresh', id: 'refresh', align: 'right' },
				"ColumnChooser"
			],
			modalObj: null,
			selectedArticles: [],
			documentType: null,
			documentTypeOptions: ['mm', 'wz', 'rw'],
			documentNumber: null,
			isGeneratingNumber: false,
			isSubmitting: false,
		}
	},

	mounted() {
		this.modalObj = new Modal(this.$refs.modalEle)

		this.initGrid()
		this.loadWarehouses()
		this.refreshDocNumber()
		this.articleDetailsModal = new Modal(
			this.$refs.articleDetailsModalRef
		)
		this.refreshDocNumber()
	},

	watch: {
		globalWarehouseId(newVal) {
			if (
				newVal &&
				this.sourceWarehouseId &&
				Number(newVal) === Number(this.sourceWarehouseId)
			) {
				this.sourceWarehouseId = null
			}

			this.reloadArticles()
		},

		async sourceWarehouseId(newVal) {
			const val = Number(newVal)

			if (
				this.globalWarehouseId &&
				Number(this.globalWarehouseId) === val
			) {
				this.globalWarehouseId = null
			}

			this.selectedArticles = []

			this.globalComment = ''
			this.globalAdditionalComment = ''
			this.globalPurpose = ''
			this.who_receiving = ''
			this.who_buying = ''
			this.customer_id = ''
			this.customerSearch = ''
			this.closeDocument = null
			this.printPdf = null

			// ustaw domyślny komentarz dla aktualnego typu dokumentu
			this.setDefaultComment()

			await nextTick()
			this.reloadArticles()
		},

		documentType() {
			this.refreshDocNumber()
			this.globalWarehouseId = null

			this.setDefaultComment()

			this.reloadArticles()
		},

		globalComment(val) {
			if (this.selectedArticles.length) {
				this.selectedArticles.forEach(a => {
					a.comment = val
				})
			}
		},

		globalAdditionalComment(val) {
			if (this.selectedArticles.length) {
				this.selectedArticles.forEach(a => {
					a.additional_comment = val
				})
			}
		},

		globalPurpose(val) {
			if (this.selectedArticles.length) {
				this.selectedArticles.forEach(a => {
					a.purpose = val
				})
			}
		},
	},

	computed: {
		sourceWarehouses() {
			let warehouses = this.warehouses

			if (this.documentType === 'wz') {
				warehouses = warehouses.filter(w => w.id === 1)
			}

			if (this.globalWarehouseId) {
				warehouses = warehouses.filter(
					w => Number(w.id) !== Number(this.globalWarehouseId)
				)
			}

			return warehouses
		},

		targetWarehouses() {

			return this.warehouses.filter(
				w => w.id !== this.sourceWarehouseId
			);
		},
		filteredCustomers() {
			if (!this.customerSearch) return this.customers

			return this.customers.filter(c =>
				c.name.toLowerCase().includes(this.customerSearch.toLowerCase())
			)
		},
		canSubmit() {
			if (this.documentType === 'pw') return true
			return this.selectedArticles.every(
				a => a.available_items?.quantity > 0
			)
		},

		hasZeroQuantityArticles() {
			return this.selectedArticles.some(
				a => !a.available_items?.quantity || a.available_items.quantity <= 0
			)
		}
	},

	methods: {
		setDefaultComment() {
			switch ((this.documentType || '').toLowerCase()) {
				case 'mm':
					this.globalComment = 'Przesunięcie między magazynami'
					break

				case 'wz':
					this.globalComment = 'Wydanie zewnętrzne'
					break

				case 'rw':
					this.globalComment = 'Rozchód wewnętrzny'
					break

				default:
					this.globalComment = ''
			}
		},

		hideDropdown() {
			// mały delay żeby click zdążył złapać wybór
			setTimeout(() => {
				this.showDropdown = false
			}, 150)
		},

		selectCustomer(customer) {
			this.customer_id = customer.id
			this.customerSearch = customer.name
			this.showDropdown = false

			const data = customer.customers_data || {}

			const lines = [
				customer.name,
				data.address,
				[data.zip_code, data.city].filter(Boolean).join(' ')
			].filter(Boolean)

			this.who_buying = lines.join('\n')

		},

		resetGlobals() {
			this.globalComment = ''
			this.globalAdditionalComment = ''
			this.who_receiving = ''
			this.who_buying = ''
			this.globalPurpose = ''
			this.customerSearch = ''
			this.customer_id = null
			this.documentType = null
			this.sourceWarehouseId = null
			this.globalWarehouseId = null
			this.closeDocument = null
			this.printPdf = null
		},

		getWarehouseName(id) {
			const wh = this.warehouses.find(w => Number(w.id) === Number(id))
			return wh?.short_name || wh?.name || `WH#${id}`
		},

		getSourceWarehouseName(id) {
			const wh = this.warehouses.find(w => Number(w.id) === Number(id))
			return wh?.short_name || wh?.name || `Magazyn #${id}`
		},

		getSourceQuantity(article) {
			const avail = article?.available_items
			const wh = Number(this.sourceWarehouseId)
			if (!avail || !wh) return 0
			const item = Array.isArray(avail)
				? avail.find(x => Number(x.article_warehouse_id) === wh)
				: avail

			return Number(item?.quantity ?? 0)
		},

		async reloadArticles() {
			//console.log('[reloadArticles] wybrany magazyn źródłowy:', this.sourceWarehouseId)
			await nextTick()
			const grid = this.$refs.addItemMovementGridRef?.ej2Instances
			if (!grid) return

			grid.pageSettings.currentPage = 1
			grid.clearFiltering?.()
			grid.clearSorting?.()

			grid.query = new Query()
				.addParams('source_warehouse_id', this.sourceWarehouseId)
				.addParams('without_deleted', true)
				.addParams('min_quantity', 1)

			grid.refresh()
		},

		getAvailableQuantity(article) {

			if (!article?.previous_warehouse_id) return 0

			const options = this.sourceOptions(article)

			const selectedWarehouse = options.find(
				x => Number(x.article_warehouse_id) === Number(article.previous_warehouse_id)
			)

			return Number(selectedWarehouse?.quantity || 0)
		},

		isIntegerUnit(unitName) {
			return unitName && ['szt', 'szt.', 'kpl'].includes(unitName.toLowerCase());
		},

		blockNonNumeric(event, unitName) {
			const allowedKeys = [
				'Backspace', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Delete', 'Tab'
			];

			if (allowedKeys.includes(event.key)) return;

			if (this.isIntegerUnit(unitName)) {
				if (!/^\d$/.test(event.key)) event.preventDefault();
			} else {
				if (!/^[\d.,]$/.test(event.key)) event.preventDefault();
			}
		},

		onQuantityInput(article) {

			if (article.quantity === null || article.quantity === '') return
			if (this.isIntegerUnit(article.article_unit?.name)) {
				article.quantity = Math.max(
					1,
					Math.floor(article.quantity || 1)
				)

			} else {
				let val = article.quantity
				if (typeof val === 'string') {
					val = val.replace(',', '.')
				}
				const parsed = parseFloat(val)
				article.quantity = isNaN(parsed)
					? null
					: parsed
			}
			if (this.documentType !== 'pw') {
				const maxQty = this.getAvailableQuantity(article)
				if (article.quantity > maxQty) {
					article.quantity = maxQty
				}
			}
		},

		initGrid() {
			this.articlesDataManager = new DataManager({
				url: route('articles.get_move'),
				adaptor: new WebMethodAdaptor(),
				headers: [
					{ 'X-CSRF-TOKEN': usePage().props.csrf_token }
				],
			});
		},

		async loadWarehouses() {
			const resp = await axios.get(route('get.article-warehouses'))
			this.warehouses = Array.isArray(resp.data) ? resp.data : []

			const firstId = this.warehouses?.[0]?.id ?? null

			if (firstId) {

				// domyślnie pierwszy magazyn
				this.sourceWarehouseId = firstId

				this.selectedArticles = this.selectedArticles.map(a => ({
					...a,
					warehouse_id: a.warehouse_id ?? firstId,
					previous_warehouse_id: firstId,
				}))

				//this.reloadArticles()
			}
		},

		addToSelected(row) {

			if (this.isArticleSelected(row.id)) return

			this.editingArticle = this.normalizeRow(row)

			this.articleDetailsModal.show()
		},
		saveArticleFromModal() {

			if (!this.editingArticle) return

			this.selectedArticles.push({
				...this.editingArticle
			})

			this.articleDetailsModal.hide()

			this.editingArticle = null
		},

		normalizeRow(row) {
			const src = row?.article ? row.article : row
			//console.log(row.available_items)
			const item = {
				id: src?.id,
				catalog_number: src?.catalog_number || '',
				model: src?.model || '',
				description: src?.description || '',
				article_unit: src?.article_unit || (src?.unit_id ? { id: src.unit_id, name: '', allow_decimal: 0 } : null),
				photos: src?.photos || [],
				available_items: row?.available_items ?? [],
				quantity: 1,
				comment: this.globalComment || '',
				additional_comment: this.globalAdditionalComment || '',
				who_issuing: `${usePage().props.user.first_name || ''} ${usePage().props.user.last_name || ''}`,
				who_receiving: this.who_receiving || '',
				who_buying: this.who_buying || '',
				purpose: this.globalPurpose || '',
				previous_warehouse_id: Number(this.sourceWarehouseId),
				warehouse_id: null,
			}
			if (this.globalWarehouseId) {
				item.warehouse_id = this.globalWarehouseId
			} else {
				const firstId = this.warehouses?.[0]?.id ?? null
				if (firstId) item.warehouse_id = firstId
			}

			return item
		},

		applyGlobalWarehouse() {
			if (!this.globalWarehouseId) return;
			const last = this._lastGlobalWarehouseId;
			for (let i = 0; i < this.selectedArticles.length; i++) {
				const item = this.selectedArticles[i];
				const hasSource = this.sourceOptions(item).length > 0;
				if (!hasSource) {
					this.selectedArticles[i].warehouse_id = this.globalWarehouseId;
					continue;
				}
				if (!item.warehouse_id || item.warehouse_id === last) {
					this.selectedArticles[i].warehouse_id = this.globalWarehouseId;
				}
			}
			this._lastGlobalWarehouseId = this.globalWarehouseId;
			this.reloadArticles();
		},

		isArticleSelected(id) {
			return this.selectedArticles.some(a => a.id === id)
		},

		removeFromSelectedArticles(id) {
			this.selectedArticles = this.selectedArticles.filter(a => a.id !== id)
		},

		sourceOptions(article) {
			const avail = article?.available_items
			if (!avail) return []

			const list = Array.isArray(avail) ? avail : [avail]

			return list.map(x => ({
				article_warehouse_id: Number(x.article_warehouse_id),
				quantity: Number(x.quantity ?? 0)
			}))
		},

		async refreshDocNumber() {
			this.documentNumber = null
			this.documentNumber = await this.generateDocumentNumber()
		},

		async generateDocumentNumber() {
			try {
				this.isGeneratingNumber = true

				const firstItem = this.selectedArticles?.[0]

				const oldWarehouse = this.warehouses?.find(
					w => Number(w.id) === Number(firstItem?.previous_warehouse_id)
				) || null

				const newWarehouse = this.warehouses?.find(
					w => Number(w.id) === Number(firstItem?.warehouse_id)
				) || null

				const { data } = await axios.get(
					route('warehouse-movements.generate-document-number-json', {
						document_type: this.documentType ?? 'mm',
						order_list_item_id: null,
						oldWarehouse,
						newWarehouse,
						fromQuoteRequest: false,
					})
				)

				return data?.number ?? null

			} catch (e) {
				console.error(e)
				return null
			} finally {
				this.isGeneratingNumber = false
			}
		},

		async submit() {
			if (!this.selectedArticles.length) {
				Toast?.fire?.({
					icon: 'warning',
					title: 'Brak pozycji',
					html: 'Najpierw dodaj co najmniej jeden artykuł.',
					toast: true,
					timer: 2500
				})
				return
			}

			const errors = []

			for (const a of this.selectedArticles) {
				const q = Number(a.quantity)

				if (!Number.isFinite(q) || q <= 0) {
					errors.push(`Artykuł #${a.id}: ilość musi być > 0`)
				}

				if (this.sourceOptions(a).length && !a.previous_warehouse_id) {
					errors.push(`Artykuł #${a.id}: wybierz magazyn źródłowy`)
				}

				if (!a.warehouse_id) {
					errors.push(`Artykuł #${a.id}: wybierz magazyn docelowy`)
				}
			}

			if (errors.length) {
				Toast?.fire({
					icon: 'error',
					title: 'Błędne dane',
					html: errors.join('<br/>')
				})
				return
			}

			if (!this.documentNumber || this._lastWarehouseSnapshot !== this.sourceWarehouseId) {
				this.documentNumber = await this.generateDocumentNumber()
				this._lastWarehouseSnapshot = this.sourceWarehouseId
			}

			const payload = {
				document_number: this.documentNumber,
				closeDocument: this.closeDocument,
				printPdf: this.printPdf,

				items: this.selectedArticles.map(a => ({
					article_id: a.id,
					quantity: Number(a.quantity),
					comment: a.comment ?? '',
					who_issuing: `${usePage().props.user.first_name ?? ''} ${usePage().props.user.last_name ?? ''}`,
					who_receiving: this.who_receiving ?? '',
					who_buying: this.who_buying ?? '',
					purpose: a.purpose ?? '',
					additional_comment: a.additional_comment ?? '',
					previous_warehouse_id: a.previous_warehouse_id ?? null,
					warehouse_id: a.warehouse_id ?? null,
				})),
			}

			//console.log('payload', payload)

			this.isSubmitting = true

			try {
				const resp = await axios.post(
					route('warehouse-movements.add-item.store', { movement: this.selectedMovement?.id }),
					payload
				)

				Toast?.fire({
					icon: resp?.data?.icon || 'success',
					title: resp?.data?.title || 'Dodano pozycje',
					html: resp?.data?.message || 'Pozycje zostały dodane do ruchu.',
					timer: 2500,
				})

				const documentNumber =
					typeof resp?.data === 'string'
						? this.documentNumber
						: (resp?.data?.document_number ?? this.documentNumber)

				if (this.printPdf) {
					window.open(
						route('warehouse-movements.preview-pdf-by-number', {
							document_number: this.documentNumber
						}),
						'_blank'
					)
				}

				this.selectedArticles = []
				this.documentNumber = null
				this._lastWarehouseSnapshot = null

				this.reloadArticles()
				this.resetGlobals()
				this.$emit('added-movement', resp?.data ?? null)
				this.$emit('data-saved', true)

				this.hide()

			} catch (e) {
				const msg =
					e?.response?.data?.message ||
					e?.message ||
					'Nie udało się dodać dokumentu.'

				Toast?.fire({
					icon: 'error',
					title: 'Błąd',
					html: msg
				})

				console.error(e)
			} finally {
				this.isSubmitting = false
			}
		},

		onToolbarClick(args) {
			if (args?.item?.id === 'reset_filters') {
				const grid = this.$refs.addItemMovementGridRef?.ej2Instances

				if (!grid) return

				grid.clearFiltering()
				grid.clearSorting()

				// wyczyść Search
				grid.searchSettings.key = ''
				grid.search('')

				grid.query = new Query()
					.addParams('source_warehouse_id', this.sourceWarehouseId)
					.addParams('without_deleted', true)
					.addParams('min_quantity', 1)

				grid.pageSettings.currentPage = 1
				grid.refresh()
			}
			if (args?.item?.id === 'articles_list') {
				window.open(route('articles.index'), '_blank')
			}
			if (args?.item?.id === 'refresh') {
				this.$refs.addItemMovementGridRef.ej2Instances.refresh()
			}

			if (args?.item.id === 'restore') {
				let grid = this.$refs.addItemMovementGridRef;
				let gridName = 'grid' + grid.$el.id;
				grid.ej2Instances.enablePersistence = false;
				window.localStorage.setItem(gridName, "");
				grid.ej2Instances.destroy();

				// usuń ?ids=... i/lub ids[]=... z aktualnego adresu
				(function stripIdsFromUrl() {
					try {
						const url = new URL(window.location.href);
						url.searchParams.delete('ids');    // np. ?ids=1,2,3
						url.searchParams.delete('ids[]');  // np. ?ids[]=1&ids[]=2
						history.replaceState(history.state, '', url.toString());
					} catch (e) {
						// fallback dla bardzo starych przeglądarek
						const href = window.location.href;
						const cleaned = href
							.replace(/([?&])ids(\[\])?=[^&#]*&?/g, '$1')
							.replace(/[?&]$/, '');
						history.replaceState(history.state, '', cleaned);
					}
				})();

				location.reload();
			}



		},

		actionBegin(args) {
			if (args.requestType === 'refresh') {
			}

			if (args.requestType === 'searching') {
				const keys = String(args.searchString || '')
					.split(',')
					.map(s => s.trim())
					.filter(Boolean)

				if (!keys.length) return

				const grid = this.$refs.addItemMovementGridRef.ej2Instances
				const cols = grid.getColumns()

				let predicate = null

				for (const key of keys) {
					for (const col of cols) {
						if (!col.field) continue

						const p = new Predicate(
							col.field,
							'contains',
							key,
							true
						)

						predicate = predicate
							? predicate.or(p)
							: p
					}
				}

				args.cancel = true

				grid.query = new Query()
					.addParams('source_warehouse_id', this.sourceWarehouseId)
					.addParams('without_deleted', true)
					.addParams('min_quantity', 1)
					.where(predicate)

				grid.refresh()
			}
		},


		actionComplete(args) {
		},
		show() {
			this.resetGlobals()
			this.selectedArticles = []
			this.documentNumber = null
			this._lastWarehouseSnapshot = null

			this.modalObj?.show()
		},
		hide() {
			this.modalObj?.hide()
		},
	},
}
</script>
